import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'
import { GET_PHARMACIES } from '../../../../queries/pharmacies'
import { PharmaciesDetailsFiltersContext } from '../../../../context/PharmaciesDetailsFiltersContext'
export default function Pharmacies (): JSX.Element {
  const { filters, setFilters } = useContext(PharmaciesDetailsFiltersContext)
  const { loading, error, data } = useQuery(GET_PHARMACIES)

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.search) return <p>No data found</p>

  const pharmacies: Array<string> = []
  data.search.map((pharmacy: any) => {
    pharmacies.push(pharmacy.pharmacyName)
  })

  const onChange = (value: string[]) => {
    setFilters({
      pharmacies: value
    })
  }

  const typographLabel = 'Farmácia'

  return (
    <Fragment>
      <AutocompleteComponent
        multiple={true}
        labelValue={typographLabel}
        data={pharmacies}
        defaultValues={filters.pharmacies}
        onChange={onChange}
      />
    </Fragment>
  )
}
